module.exports = __webpack_public_path__ + "static/media/tp_sculpin.61619ba6.jpg";